import type { ListingPageProps } from 'components/listing-page'
import { ListingPage } from 'components/listing-page'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getEmailPathsAndStatus } from 'services/email-service-helpers'
import type { NextPageContextWithI18n } from '../types'

export default function Index(props: ListingPageProps) {
    if (!props.isDevMode) return 'OK'
    return <ListingPage {...props} isDevMode />
}

export async function getServerSideProps(context: NextPageContextWithI18n) {
    const emails = await getEmailPathsAndStatus()

    return {
        props: {
            emails,
            baseURL: process.env.BASE_URL,
            isDevMode: process.env.NODE_ENV === 'development',
            ...(await serverSideTranslations(context.locale, [])),
        },
    }
}
